export enum StatusValidation {
  Valide = 'valide',
  AValider = 'aValider',
  ARevoir = 'aRevoir',
  NonRecu = 'nonRecu',
}